
    import "/home/git/waysglob/website/src/components/how-we-help-item/index.module.scss.FARM_CSS_MODULES?6894d443";
    
    export default {"title": `title-3f6a5e6c`,"card": `card-3f6a5e6c`,"image": `image-3f6a5e6c`,"description": `description-3f6a5e6c`,"link": `link-3f6a5e6c`}
    